import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconDocumentSvg } from "./IconDocumentSvg.mjs";
const IconDocument = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconDocumentSvg, ...svgProps }) });
export {
  IconDocument
};
